import React, {useContext} from 'react'
import {LocalContext} from "../../modules/local/LocalContext";
import TooltipApp from "../TooltipApp";
import {formatSimplifyDate} from "../../helpers/dateUtils";
import dayjs from "dayjs";

const Timestamp = React.memo(({timestamp, formatTimeDate, children, className = 'tracking-wide'}) => {

    const {lang} = useContext(LocalContext)
    dayjs.locale(lang)

    const year = dayjs(timestamp).year()
    const currentYear = dayjs().year()

    if (!!timestamp && (year !== currentYear) && (formatTimeDate === true)) {
        return (
            <label className="whitespace-no-wrap text-2xs text-color-300 hover:text-color-100 cursor-pointer">
                {formatSimplifyDate(timestamp, 'fullTime')}
            </label>
        )
    }
    if (!!timestamp && (year !== currentYear) && (formatTimeDate === false)) {
        return (
            <TooltipApp title={formatSimplifyDate(timestamp, 'fullTime')} placement="bottomLeft"
                        classNames={{root: "text-xs italic"}}>
                <label className="whitespace-no-wrap text-2xs text-color-300 hover:text-color-100 cursor-pointer">
                    {formatSimplifyDate(timestamp, 'medium')}
                </label>
            </TooltipApp>
        )
    }
    if (!!timestamp && (year === currentYear)) {
        return (
            <TooltipApp title={formatSimplifyDate(timestamp, 'fullTime')} placement="bottomLeft"
                        classNames={{root: "text-xs italic"}}>
                <label className="whitespace-no-wrap text-2xs text-color-300 hover:text-color-100 cursor-pointer">
                    {formatSimplifyDate(timestamp, 'medium')}
                </label>
            </TooltipApp>
        )
    }
    return (
        <TooltipApp title={formatSimplifyDate(timestamp, 'fullTime')} placement="bottomLeft"
                    classNames={{root: "text-xs italic"}}>
            <label className="whitespace-no-wrap text-2xs text-color-300 hover:text-color-100 cursor-pointer">
                {formatSimplifyDate(timestamp || children,)}
            </label>
        </TooltipApp>
    )
})
export default Timestamp
